<template>
  <div class="new-Transfer">
    <div class="box">
      <div class="box-left">
        <div class="box-left_title">
          <p class="box-left_titleP">字段映射</p>
        </div>
        <div class="box-left_body">
          <el-row>
            <el-col :span="12">
              <div class="field-box">
                <div class="field-box_title">
                  <p>系统字段</p>
                </div>
                <el-form
                  :model="systeRuleForm"
                  :rules="systeRules"
                  ref="systeRuleForm"
                  class="demo-ruleForm"
                  @validate="validateValue"
                  :show-message="false"
                >
                  <div class="field-box_body">
                    <el-form-item prop="ISsystematicRadio">
                      <el-radio-group
                        v-model="systeRuleForm.ISsystematicRadio"
                        @change="systematic"
                      >
                        <el-radio
                          class="Radio"
                          v-for="(item,key) in systematicRadio"
                          :key="key"
                          :label="key"
                          :title="item.columnName"
                        >
                          <span class="ISbixuan" v-if="item.is_must == 1">*</span>
                          {{item.columnName}}
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="field-box" style="border:none;">
                <div class="field-box_title">
                  <p>excel表头</p>
                </div>
                <el-form
                  :model="excelRuleForm"
                  :rules="excelRules"
                  ref="excelRuleForm"
                  class="demo-ruleForm"
                  @validate="validateValue"
                  :show-message="false"
                >
                  <div class="field-box_body">
                    <el-form-item prop="ISexcelRadio">
                      <el-radio-group v-model="excelRuleForm.ISexcelRadio" @change="excel">
                        <el-radio
                          class="Radio"
                          v-for="(item,key) in excelRadio"
                          :key="key"
                          :label="key"
                          :title="item"
                        >{{item}}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="box-center">
        <div class="buttons">
          <el-button @click="goRelationcommit()" class="box-center_buttonRight" size="small">
            <i class="el-icon-right"></i>
          </el-button>
          <el-button @click="goDeletecommit()" class="box-center_buttonLeft" size="small">
            <i class="el-icon-back"></i>
          </el-button>
        </div>
      </div>
      <div class="box-right">
        <div class="box-right_title">
          <p class="box-right_titleP">关系列表</p>
        </div>
        <el-form
          :model="relationRuleForm"
          :rules="relationRules"
          ref="relationRuleForm"
          class="demo-ruleForm"
          @validate="validateValue"
          :show-message="false"
        >
          <div class="box-right_body">
            <el-form-item prop="ISrelation">
              <el-checkbox-group v-model="relationRuleForm.ISrelation">
                <el-checkbox
                  v-for="(checked,key) in relationCheckbox"
                  :key="key"
                  class="check"
                  :label="key"
                >{{checked.columnName}}&lt;=&gt;{{checked.configure}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    //系统字段渲染列表
    systematicRadio:{
      type:Array
    },
    //excel表头渲染列表
    excelRadio:{
      type:Array
    },
    //关系列表渲染列表
    relationCheckbox:{
      type:Array
    }
  },
  data() {
    return {
      //系统字段渲染列表
      // systematicRadio: [
      //   {
      //     is_must: 1, // 是否必填 1 必填 0 可选
      //     column: "campusName", //需要匹配字段
      //     columnName: "校区名称" //需要匹配字段的中文名称
      //   },
      //   {
      //     is_must: 0,
      //     column: "address",
      //     columnName: "校区地址"
      //   },
      //   {
      //     is_must: 0,
      //     column: "postcode",
      //     columnName: "校区邮政编码啊"
      //   }
      // ],
      //系统字段选中结果
      systeRuleForm: {
        ISsystematicRadio: ""
      },
      //系统字段表单验证
      systeRules: {
        ISsystematicRadio: [
          {
            required: true,
            message: "请选择需要匹配的系统字段",
            trigger: "blur"
          }
        ]
      },
      //excel表头渲染列表
      // excelRadio: [
      //   "校区代码",
      //   "校区名称",
      //   "校区地址",
      //   "邮政编码",
      //   "状态",
      //   "备注",
      //   "负责人姓名",
      //   "负责人工号"
      // ],
      //excel表头选中结果
      excelRuleForm: {
        ISexcelRadio: ""
      },
      //excel表头验证
      excelRules: {
        ISexcelRadio: [
          { required: true, message: "请选择需要匹配的excel", trigger: "blur" }
        ]
      },
      //关系列表渲染列表
      // relationCheckbox: [
      //   {
      //     is_must: 1, // 是否必填 1 必填 0 可选
      //     column: "1", // 需要匹配字段
      //     configure: "1", // excel中的表头
      //     columnName: "1" // 需要匹配字段的中文名称
      //   },
      //   {
      //     is_must: 1, // 是否必填 1 必填 0 可选
      //     column: "2", // 需要匹配字段
      //     configure: "2", // excel中的表头
      //     columnName: "2" // 需要匹配字段的中文名称
      //   }
      // ],
      //关系列表选中结果
      relationRuleForm: {
        ISrelation: []
      },
      //关系列表验证
      relationRules: {
        ISrelation: [
          {
            required: true,
            message: "请选择需要取消匹配的关系",
            trigger: "blur"
          }
        ]
      },
      //系统字段选中进行匹配的字段
      ISsys: {},
      //excel表头选中进行匹配的字段
      ISexcel: ""
    };
  },
  methods: {
    //系统字段选中值
    systematic(val) {
      console.log("系统字段选中值", val);
      this.ISsys = this.systematicRadio[val];
      console.log("这是我选中的待匹配系统字段", this.ISsys);
    },
    //excel表头选中值
    excel(val) {
      console.log("excel选中值", val);
      this.ISexcel = this.excelRadio[val];
      console.log("这是我选中的待匹配excel表头字段", this.ISexcel);
    },
    //表单验证规则
    validateValue(prop, msgStatus, validateMessage) {
      if (validateMessage) {
        this.$message.error(validateMessage);
      }
    },
    // 匹配关系提交表单
    goRelationcommit() {
      this.$nextTick(() => {
        this.$refs.systeRuleForm.validate(sysvalid => {
          console.log("sysvalid", sysvalid);
          if (sysvalid) {
            this.$refs.excelRuleForm.validate(valid => {
              console.log("valid", valid);
              if (valid) {
                return this.goRelation();
              } else {
                return false;
              }
            });
          } else {
            return false;
          }
        });
      });
    },
    // 取消匹配关系提交表单
    goDeletecommit() {
      this.$nextTick(() => {
        this.$refs.relationRuleForm.validate(valid => {
          console.log("sysvalid", valid);
          if (valid) {
            return this.goDelete();
          } else {
            return false;
          }
        });
      });
    },
    //匹配关系
    goRelation() {
      console.log("匹配关系");
      //将左侧字段映射进行匹配并加入右侧已匹配的关系列表中
      const RelationList = this.ISsys;
      RelationList.configure = this.ISexcel;
      console.log("这是匹配的关系", RelationList);
      this.relationCheckbox.push(RelationList);
      console.log("添加的匹配关系", this.relationCheckbox);
      //将左侧刚进行匹配的数据删除并清空选中目标绑定
      this.systematicRadio.splice(this.systeRuleForm.ISsystematicRadio, 1);
      this.systeRuleForm.ISsystematicRadio = "";
      this.excelRadio.splice(this.excelRuleForm.ISexcelRadio, 1);
      this.excelRuleForm.ISexcelRadio = "";
      this.ISsys = {};
      this.ISexcel = "";
    },
    //取消匹配关系
    goDelete() {
      console.log("取消选中的匹配关系", this.relationRuleForm.ISrelation);
      //将保存的多选选项下标按降序排序，试删除从后往前删
      this.relationRuleForm.ISrelation.sort(function(a, b) {
        return b - a;
      });
      console.log(this.relationRuleForm.ISrelation);
      this.relationRuleForm.ISrelation.forEach(row => {
        console.log("这是需要取消匹配的关系", this.relationCheckbox[row]);
        this.excelRadio.push(this.relationCheckbox[row].configure);
        console.log(
          "这是取消关系时重新添加后的excel表头待匹配列表",
          this.excelRadio
        );
        const DeleteList = {
          is_must: this.relationCheckbox[row].is_must, // 是否必填 1 必填 0 可选
          column: this.relationCheckbox[row].column, //需要匹配字段
          columnName: this.relationCheckbox[row].columnName //需要匹配字段的中文名称
        };
        this.systematicRadio.push(DeleteList);
        console.log(
          "这是取消关系时重新添加后的系统字段待匹配列表",
          this.systematicRadio
        );
        this.relationCheckbox.splice(row, 1);
        console.log("取消删除后的关系列表", this.relationCheckbox);
      });
      this.relationRuleForm.ISrelation = [];
    }
  }
};
</script>

<style lang="scss">
.new-Transfer {
  .box {
    width: 100%;
    height: 336px;
    text-align: left;
    .box-left {
      display: inline-block;
      // float: left;
      border: 1px solid #f2f2f2;
      border-radius: 4px;
      width: 246px;
      height: 336px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(220, 222, 226, 1);
      &_title {
        width: 100%;
        background: rgba(239, 239, 244, 1);
        border-bottom: 1px solid rgba(220, 222, 226, 1);
        float: left;
        height: 32px;
        line-height: 32px;
        &P {
          margin: 0;
          margin-left: 20px;
          text-align: left;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFangSC;
          font-weight: 400;
          color: rgba(46, 63, 87, 1);
        }
      }
      &_body {
        height: 304px;
        .field-box {
          height: 304px;
          border-right: 1px solid #dcdee2;
          &_title {
            height: 32px;
            line-height: 32px;
            p {
              text-align: left;
              margin: 0;
              padding-left: 16px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFangSC;
              font-weight: 500;
              color: rgba(46, 64, 87, 1);
            }
          }
          &_body {
            height: 271px;
            padding-left: 16px;
            overflow-y: auto;
            .Radio {
              //   width: 100%;
              width: 89px;
              height: 28px;
              line-height: 28px;
              margin: 0;
              text-align: left;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFangSC;
              font-weight: 400;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              .ISbixuan {
                font-size: 12px;
                color: #ff3b30;
              }
            }
          }
        }
      }
    }
    .box-center {
      display: inline-block;
      // float: left;
      width: 66px;
      height: 336px;
      line-height: 336px;
      text-align: center;
      position: relative;
      .buttons {
        position: absolute;
        top: 50%;
        margin-top: -24px;
        left: 50%;
        margin-left: -12px;
      }
      button {
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(45, 140, 240, 1);
        color: #2d8cf0;
      }
      &_buttonLeft {
        width: 24px;
        height: 16px;
        display: block;
        margin: 0;
        // margin-left: 30%;
        margin-top: 17px;
        padding: 0;
      }
      &_buttonRight {
        width: 24px;
        height: 16px;
        // margin-left: 25%;
        padding: 0;
        display: block;
      }
    }
    .box-right {
      display: inline-block;
      // float: left;
      border: 1px solid #f2f2f2;
      border-radius: 4px;
      width: 246px;
      height: 336px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(220, 222, 226, 1);
      &_title {
        width: 100%;
        background: rgba(239, 239, 244, 1);
        border-bottom: 1px solid rgba(220, 222, 226, 1);
        float: left;
        height: 32px;
        line-height: 32px;
        &P {
          margin: 0;
          margin-left: 20px;
          text-align: left;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFangSC;
          font-weight: 400;
          color: rgba(46, 63, 87, 1);
        }
      }
      &_body {
        height: 304px;
        padding-left: 16px;
        overflow-y: auto;
        .check {
          width: 228px;
          height: 32px;
          line-height: 32px;
          margin-right: 0;
          text-align: left;
        }
      }
    }
  }
  .el-radio__label {
    padding-left: 4px !important;
  }
  .el-form-item__content {
    line-height: normal !important;
  }
}
</style>
